import { Link } from 'react-router-dom'

const logo = require('../assets/img/logo.png')

export default function Logo() {
      return (
            <Link to={'/'} className='logo'>
                  <img className='logo-img h-12 w-auto' src={logo} alt="Logo" />
                  {/* <h2 className='logo-title'>ManageGear</h2> */}
            </Link>
      )
}
